import logo from '@/assets/images/logo_dark_sm.png';
import { Box, Image, Text, Title } from '@mantine/core';
import { useEffect } from 'react';
import styles from './ServicePaused.module.scss';

export default function ServicePaused() {
  useEffect(() => {
    document.title = 'LoveInvoice — Temporarily paused';
  }, []);

  return (
    <main className={styles.page}>
      <section className={styles.notice} aria-labelledby="service-paused-title">
        <header className={styles.header}>
          <Image src={logo} alt="LoveInvoice" w={152} />
          <span className={styles.status}>Service paused</span>
        </header>

        <Box className={styles.rule} aria-hidden="true" />

        <Text className={styles.eyebrow}>A note from LoveInvoice</Text>
        <Title id="service-paused-title" order={1} className={styles.title}>
          We’re taking a pause.
        </Title>
        <Text className={styles.message}>
          We’re pausing the LoveInvoice service for a little while. We’ll be back as soon as we can.
        </Text>
        <Text className={styles.detail}>For now, you won’t be able to log in or create an account.</Text>
      </section>
    </main>
  );
}
